import React from 'react'
import { element, func, string, bool, node, object } from 'prop-types'
import { Form, NumberInput } from '@cobalt/cobalt-react-components'
import { SetupMFAStep } from '../../components'
import QRCode from 'qrcode.react'
import { AuthenticatorAppDownload } from './AuthenticatorAppDownload'
import {
  NEXT,
  FINISH,
  SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP,
  SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP,
  SETUP_MFA_TOTP_TITLE,
  SETUP_MFA_TOTP_FOOTNOTE,
  SETUP_MFA_TOTP_VERIFICATION_CODE,
  SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER
} from '../../constants/ui.labels'
import { LEARN_MORE_ABOUT_AUTHENTICATOR_APP } from '../../constants/links'

const SetupTOTPStep = props => (
  <SetupMFAStep
    title={SETUP_MFA_TOTP_TITLE}
    footnoteLabel={SETUP_MFA_TOTP_FOOTNOTE}
    footnoteUrl={LEARN_MORE_ABOUT_AUTHENTICATOR_APP}
    {...props}
  >
    {props.children}
  </SetupMFAStep>
)

SetupTOTPStep.propTypes = {
  subtitle: string.isRequired,
  boxContent: node.isRequired,
  buttonLabel: string.isRequired,
  buttonAction: func.isRequired,
  onCancel: func.isRequired,
  isProcessing: bool,
  errorCode: string,
  buttonDisabled: bool,
  children: element
}

export const StartRegistrationStep = ({
  onPrepareRegistration,
  ...otherProps
}) => (
  <SetupTOTPStep
    subtitle={SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP}
    boxContent={<AuthenticatorAppDownload />}
    buttonLabel={NEXT}
    buttonAction={onPrepareRegistration}
    {...otherProps}
  />
)

StartRegistrationStep.propTypes = {
  onCancel: func.isRequired,
  onPrepareRegistration: func.isRequired,
  errorCode: string,
  isProcessing: bool
}

export class RegisterStep extends React.Component {
  state = { otp: '' }

  static propTypes = {
    onCancel: func.isRequired,
    onFinishRegistration: func.isRequired,
    registrationData: object,
    errorCode: string,
    isProcessing: bool,
    buttonDisabled: bool
  }

  componentDidUpdate = previousProps =>
    previousProps.isProcessing && !this.props.isProcessing
      ? this.setState({ otp: '' })
      : null

  finishRegistration = () => {
    this.props.onFinishRegistration({
      registrationToken: this.props.registrationData.token,
      otp: this.state.otp
    })
  }

  handleOTPChange = event => this.setState({ otp: event.target.value })

  render() {
    const {
      registrationData: { uri },
      isProcessing,
      ...otherProps
    } = this.props

    return (
      <SetupTOTPStep
        subtitle={SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP}
        boxContent={<QRCode value={uri} />}
        buttonLabel={FINISH}
        buttonAction={this.finishRegistration}
        buttonDisabled={!this.state.otp}
        isProcessing={isProcessing}
        {...otherProps}
      >
        <Form.Field
          label={SETUP_MFA_TOTP_VERIFICATION_CODE}
          disabled={isProcessing}
        >
          <NumberInput
            value={this.state.otp}
            onChange={this.handleOTPChange}
            placeholder={SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER}
            autoFocus
          />
        </Form.Field>
      </SetupTOTPStep>
    )
  }
}
